import { render } from "./WorkHistory.vue?vue&type=template&id=4a602128&scoped=true"
import script from "./WorkHistory.vue?vue&type=script&lang=js"
export * from "./WorkHistory.vue?vue&type=script&lang=js"

import "./WorkHistory.vue?vue&type=style&index=0&id=4a602128&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a602128"]])

export default __exports__